import type { ReportBlock, ReportContentV2 } from '@zhcb/shared';
import { isLegacyContent } from '@zhcb/shared';

/**
 * v1 舊章節鍵 → 顯示標題（順序即顯示序）
 * 舊版報告包含 basicInfo、auditScope、findings、conformityAssessment、certificationRecommendation 五個章節。
 */
const LEGACY_SECTION_TITLES: Record<string, string> = {
  basicInfo: '基本資料',
  auditScope: '稽核範圍',
  findings: '稽核發現事項',
  conformityAssessment: '標準符合性評估',
  certificationRecommendation: '授證推薦意見',
};

/**
 * 把任意 content 正規化為可渲染的 blocks。
 * - v2（板塊化）：直接回傳 blocks，legacy = false。
 * - v1（舊版 5 章節）：平鋪為唯讀塊，legacy = true。
 * - 空值/未知格式：回傳空塊，legacy = false。
 */
export function normalizeReportContent(content: unknown): {
  blocks: ReportBlock[];
  legacy: boolean;
} {
  // 判斷是否為舊版 v1 格式（帶 basicInfo / auditScope 等鍵，無 schemaVersion: 2）
  if (isLegacyContent(content)) {
    const obj = content as Record<string, { title?: string; content?: string }>;
    const blocks: ReportBlock[] = Object.keys(LEGACY_SECTION_TITLES)
      .filter((k) => obj[k])
      .map((k) => ({
        key: k,
        title: obj[k]?.title ?? LEGACY_SECTION_TITLES[k]!,
        kind: 'data' as const,
        markdown: obj[k]?.content ?? '',
        editedByUser: false,
      }));
    return { blocks, legacy: true };
  }

  // v2 板塊化格式或空值
  const v2 = content as ReportContentV2 | null;
  return { blocks: v2?.blocks ?? [], legacy: false };
}
